import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const TransportationConditionList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="transportationCondition"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default TransportationConditionList;
